<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> Produto </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="product.id">
          {{ product.company.code }}{{ product.reference }} -
          {{ product.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon>
          Voltar
        </v-btn>
        <v-btn dark color="green darken-3" class="ml-2" @click="saveProduct()">
          Salvar
          <v-icon right>mdi-check</v-icon>
        </v-btn>
        <progress-bar :loading="loading" :inderterminate="loading" />
      </v-toolbar>
      <v-container fluid>
        <v-card elevation="2">
          <v-card-title class="text-h6">Dados Gerais</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="product.reference"
                  class="text-field-uppercase"
                  label="Código do Produto"
                  dense
                  readonly
                  required
                  :rules="[rules.required]"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="product.name"
                  class="text-field-uppercase"
                  label="Nome"
                  dense
                  required
                  :rules="[rules.required]"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  :items="units"
                  item-text="name"
                  item-value="id"
                  v-model="product.unit_id"
                  label="Unidade"
                  outlined
                  required
                  :rules="[rules.required]"
                  dense
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  :items="grids"
                  item-text="name"
                  item-value="id"
                  v-model="product.grid_id"
                  label="Grade"
                  outlined
                  required
                  :rules="[rules.required]"
                  dense
                ></v-select>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  :items="productTypes"
                  item-text="name"
                  item-value="id"
                  v-model="product.product_type_id"
                  label="Tipo Produto"
                  @change="changeProductType()"
                  outlined
                  required
                  :rules="[rules.required]"
                  dense
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  v-model="product.category_id"
                  label="Categoria"
                  @change="changeCategory()"
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  :items="filterByCategory(subcategories)"
                  item-text="name"
                  item-value="id"
                  v-model="product.subcategory_id"
                  label="Subcategoria"
                  dense
                  outlined
                  required
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  class="text-field-uppercase"
                  label="Preço Rede"
                  dense
                  outlined
                  v-model="product.price_cif"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  class="text-field-uppercase"
                  label="Preço Multimarcas"
                  v-model="product.price_mult"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="product.ncm"
                  class="text-field-uppercase"
                  label="NCM"
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="product.cest"
                  class="text-field-uppercase"
                  label="CEST"
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="product.cst_origem"
                  class="text-field-uppercase"
                  label="CST Origem"
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="product.cst_tribut"
                  class="text-field-uppercase"
                  label="CST Tribut."
                  dense
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
              <v-col></v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card
          elevation="2"
          class="mt-5"
          style="min-height: 170px"
          v-if="false"
        >
          <v-card-title class="text-h6">Ficha Técnica</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <!-- <label class="text-h6"></label> -->
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col
                v-for="item in extraFields"
                :key="item.id"
                cols="12"
                xs="12"
                md="2"
              >
                <v-select
                  v-if="item.type == 'selection'"
                  :items="item.values"
                  :label="item.name"
                  item-text="text"
                  item-value="value"
                  v-model="productSelected.ficha_tecnica.extra_fields[item.id]"
                  dense
                  outlined
                ></v-select>
                <v-text-field
                  v-if="item.type == 'text'"
                  class="text-field-uppercase"
                  :label="item.name"
                  dense
                  outlined
                  v-model="productSelected.ficha_tecnica.extra_fields[item.id]"
                ></v-text-field>
                <v-select
                  v-if="item.type == 'table' && item.values.table == 'soles'"
                  :items="soles"
                  :label="item.name"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  v-model="productSelected.ficha_tecnica.extra_fields[item.id]"
                ></v-select>
                <v-text-field
                  v-if="item.type == 'table' && item.values.table == 'grids'"
                  class="text-field-uppercase"
                  :label="item.name"
                  readonly
                  :value="numOfGrid"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row> -->
          </v-card-text>
        </v-card>
        <v-card elevation="2" class="mt-5" style="min-height: 150px">
          <v-card-title class="text-h6">Material / Cor</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <!-- <label class="text-h6"></label> -->
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-simple-table dense fixed-header height="300px">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Material</th>
                        <th class="text-left">Cor</th>
                        <th class="text-left" width="380">Foto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="material in product.attributes"
                        :key="`${product.reference}-${material.material_id}-${material.color_id}`"
                      >
                        <td>
                          {{ material.material.code }} -
                          {{ material.material.name }}
                        </td>
                        <td>
                          {{ material.color.code }} -
                          {{ material.color.name }}
                        </td>
                        <td>
                          <v-row>
                            <v-col>
                              <v-img
                                contain
                                max-width="133"
                                :aspect-ratio="16 / 9"
                                :src="getUrlImage(material.photo)"
                                class="image-product"
                                @click="
                                  () =>
                                    showImageFullScreen(
                                      getUrlImage(material.photo)
                                    )
                                "
                              ></v-img>
                            </v-col>
                            <v-col class="align-self-center">
                              <v-btn
                                color="green darken-3"
                                dark
                                class="mt-0"
                                small
                                outlined
                                @click="showImageGalery(material)"
                              >
                                <v-icon>mdi-image</v-icon>
                                Selecionar Foto
                              </v-btn>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- <v-card class="mt-3">
          <v-card-actions>
            <span class="font-weight-normal text-subtitle">
              Produto <b>{{ indexProduct + 1 }}</b> de
              <b>{{ produtos.length }}</b>
            </span>
            <v-spacer></v-spacer>

            <v-btn
              color="grey darken-3"
              @click="goToPrev()"
              class="ma-2 float-right"
              :loading="loadingProductPrev"
              text
            >
              <v-icon left> mdi-chevron-left </v-icon>
              Produto Anterior
            </v-btn>
            <v-btn
              color="green darken-3"
              @click="saveProducts()"
              v-if="showSalvar"
              dark
              class="ma-2 float-right"
            >
              <v-icon left> mdi-check </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="blue ligthen-3"
              v-if="!showSalvar"
              @click="goToNext()"
              :loading="loadingProduct"
              class="ma-2 float-right"
              dark
            >
              Próximo Produto
              <v-icon right> mdi-chevron-right </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card> -->
      </v-container>
    </div>
    <v-dialog v-model="dialogImageFullScreen" scrollable max-width="1300">
      <v-card>
        <!-- <v-toolbar color="green lighten-1" dark class="text-h5">
          Atenção
        </v-toolbar> -->
        <v-card-text>
          <v-spacer></v-spacer>
          <v-img
            contain
            max-width="1200"
            :aspect-ratio="16 / 9"
            :src="imageFullScreen"
          ></v-img>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogImageFullScreen = false"
          >
            Fechar
          </v-btn>
          <!-- <v-btn color="green darken-1" dark @click="confirmSave()">
            <v-icon dark>mdi-check</v-icon>
            Salvar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImageGalery"
      persistent
      scrollable
      max-width="1400px"
    >
      <v-card>
        <v-card-title class="green text-h5 white--text lighten-2"
          >Galeria de Fotos</v-card-title
        >
        <v-divider></v-divider>
        <progress-bar
          :loading="loadingPhotos"
          :inderterminate="loadingPhotos"
        />
        <v-card-text class="mt-2 subtitle-1">
          <span>
            Produto Selecionado: <b>{{ product.reference }}</b>
          </span>
          <span>
            Material:
            <b>
              {{ attributeSelected.material.code }} -
              {{ attributeSelected.material.name }}
            </b>
          </span>
          <span>
            Cor:
            <b>
              {{ attributeSelected.color.code }} -
              {{ attributeSelected.color.name }}
            </b>
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="mt-2">
          <v-row class="mt-2">
            <v-col cols="12" xs="12" md="3">
              <v-select
                v-model="collection"
                :items="collections"
                item-text="name"
                item-value="id"
                label="Coleção"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <!-- <v-col>
              <v-select
                v-model="provider"
                :items="providers"
                label="Fornecedor"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col> -->
            <v-col cols="12" xs="12" md="3">
              <v-btn
                color="blue darken-3"
                dark
                class="mt-0"
                @click="getPhotosProducts()"
              >
                <v-icon left>mdi-image</v-icon> Carregar Fotos
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-h6 black--text">Fotos</label>
              <v-divider></v-divider>
              <label v-if="showImages" class="body-1 black--text float-right"
                >{{ photos.length }} Fotos</label
              >
            </v-col>
          </v-row>
          <v-row v-if="showImages">
            <v-radio-group v-model="radioPhoto" row>
              <v-col
                v-for="photo in photos"
                :key="photo.id"
                class="d-flex child-flex"
                cols="4"
              >
                <v-card>
                  <v-carousel show-arrows-on-hover height="300">
                    <v-carousel-item
                      v-for="(item, i) in getItensPhoto(photo)"
                      :key="i"
                    >
                      <v-img
                        :src="item.full_url"
                        :lazy-src="item.full_url"
                        aspect-ratio="1.7777"
                        class="grey lighten-2 image-product"
                        @click="handleClickPhoto(photo.id)"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-carousel-item>
                  </v-carousel>
                  <!-- <v-img
                    :src="photo.full_url"
                    :lazy-src="photo.full_url"
                    aspect-ratio="1.7777"
                    class="grey lighten-2 image-product"
                    @click="handleClickPhoto(photo.id)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img> -->
                  <v-card-text class="caption">
                    <v-radio
                      :key="photo.id"
                      :label="photo.name"
                      :value="photo.id"
                    ></v-radio>
                    <!-- {{ photo.name }} -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-radio-group>
            <v-col v-if="photos.length === 0">
              <p class="title">Nenhuma foto encontrada nessa Coleção</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogImageGalery = false">
            Fechar
          </v-btn>
          <v-btn color="green darken-1" dark @click="handleSelectPhoto()">
            Selecionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL, URL_IMAGE } from "@/api/config";

import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as GridAPI from "@/api/requests/GridRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";
import * as UnitAPI from "@/api/requests/UnitRequest";

import ProgressBar from "@/components/ProgressBar";
import imageNotFound from "@/assets/produto-sem-imagem.jpg";

export default {
  components: {
    ProgressBar,
  },
  data: () => ({
    provider_id: 18,
    page: "home",
    expanded: [],
    produtos: [],
    empresa: {
      cnpj: "",
      nome: "",
    },
    typeProduct: "",
    loading: false,
    loadingPhotos: false,
    error: "",
    company: "",
    companies: [],
    valid: true,
    lazy: false,
    dialogExample: false,
    dialogSaveProducts: false,
    successSave: false,
    statusAlert: false,
    messageAlert: "",
    typeAlert: "error",
    soles: [],
    file: "",
    errorXmlMessage: "",
    xml: {
      produtos: {
        produto: [],
      },
    },
    dialogImageGalery: false,
    providers: [],
    provider: "",
    collection: "",
    collections: [],
    showImages: false,
    grids: [],
    units: [],
    productTypes: [],
    productSelected: {},
    product: {},
    extraFields: [],
    category_id: "",
    subcategories: [],
    categories: [],
    showSalvar: false,
    loadingProduct: false,
    loadingProductPrev: false,
    imageNotFound: imageNotFound,
    dialogImageFullScreen: false,
    imageFullScreen: "",
    photos: [],
    radioPhoto: "",
    attributeSelected: {
      material: {},
      color: {},
    },
    materials: [],
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    indexProduct: 0,
  }),
  computed: {
    numOfGrid: function () {
      if (typeof this.productSelected.grid !== "undefined") {
        let gridSelected = this.grids.find(
          (item) => item.id === this.productSelected.grid
        );
        return `${gridSelected.sizes[0].size} até ${
          gridSelected.sizes[gridSelected.sizes.length - 1].size
        }`;
      }
      return "";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getProduct(this.$route.params.id);
      }
      this.getGrids();
      this.getUnits();
      this.getSoles();
      this.getCategories();
      this.getSubcategories();
      this.getProductTypes();
      this.getCollections();
    },
    validate() {
      // console.log(this.file);
      let form = new FormData();
      if (this.file === "" || this.file == undefined) {
        this.showAlert("error", "Selecione um arquivo para poder continuar");
        return false;
      }
      form.append("file", this.file);
      this.xmlValidate(form);
      // if (this.$refs.form.validate()) {}
    },
    goToBackList() {
      this.$router.push({ name: "ProductListImport" });
    },
    onFilePicked(e) {
      this.file = e;
      this.errorXmlMessage = "";
    },
    async xmlValidate(data) {
      this.loading = false;
      try {
        let res = await fetch(`${URL}product-import/validate`, {
          method: "POST",
          body: data,
        });
        if (res) {
          let response = await res.json();
          this.xml = response;
          // this.empresa = { nome: response.empresa, cnpj: response.cnpj };
          // this.produtos = response.produtos;
          // this.dialogExample = true;
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    mostrarItem(item) {
      console.log(item);
    },
    getMaterials(product) {
      // let product = this.productSelected;
      let data = [];
      if (Array.isArray(product.materiais.material)) {
        product.materiais.material.map((item) => {
          if (Array.isArray(item.cores)) {
            let tempData = item.cores.map((cor) => {
              return {
                material: item.material_existe ? item.material_db : false,
                material_code: item.fmatcod,
                cor: cor.cor.cor_existe ? cor.cor.cor_db : false,
                cor_code: cor.cor.fcrcod,
                photo_url: imageNotFound,
                eans: cor.cor.eans,
                photo: {},
              };
            });
            data = [...data, ...tempData];
          } else {
            let tempData = item.cores.cor.map((corIn) => {
              return {
                material: item.material_existe ? item.material_db : false,
                material_code: item.fmatcod,
                cor: corIn.cor_existe ? corIn.cor_db : false,
                cor_code: corIn.fcrcod,
                photo_url: imageNotFound,
                photo: {},
              };
            });
            data = [...data, ...tempData];
          }
        });
      }
      return data;
    },
    getColors(product) {
      if (Array.isArray(product.materiais.material)) {
        return product.materiais.material.reduce((acc, item) => {
          if (Array.isArray(item.cores)) {
            return acc + item.cores.length;
          } else {
            return acc + 1;
          }
        }, 0);
      } else {
        if (Array.isArray(product.materiais.material.cores)) {
          return product.materiais.material.cores.length;
        } else {
          return 1;
        }
      }
    },
    async getGrids() {
      this.loading = true;
      try {
        let data = await GridAPI.getAll();
        this.grids = data.sort((a, b) => (a.id > b.id ? 1 : -1));
      } catch (error) {
        this.grids = {};
      } finally {
        this.loading = false;
      }
    },
    async getUnits() {
      this.loading = true;
      try {
        let data = await UnitAPI.getAll();
        this.units = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.units = {};
      } finally {
        this.loading = false;
      }
    },
    async getSubcategories() {
      this.loading = true;
      try {
        let data = await SubcategoryAPI.getAll();
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.subcategories = {};
      } finally {
        this.loading = false;
      }
    },
    async getProduct(id) {
      this.loading = true;
      try {
        let response = await fetch(`${URL}product/${id}`);
        let data = await response.json();
        console.log(data);
        this.product = data;
        this.changeCategory();
      } catch (error) {
        this.product = {};
      } finally {
        this.loading = false;
      }
    },
    async getCategories() {
      this.loading = true;
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // if (this.productSele.id !== "") {
        //   this.changeCategory();
        // }
      } catch (error) {
        this.categories = {};
      } finally {
        this.loading = false;
      }
    },
    async getSoles() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}sole`);
        let data = await response.json();
        this.soles = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.soles = {};
      } finally {
        this.loading = false;
      }
    },
    async getProductTypes() {
      this.loading = true;
      try {
        let response = await fetch(`${URL}product-types`);
        let data = await response.json();
        this.productTypes = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.productTypes = {};
      } finally {
        this.loading = false;
      }
    },
    async getCollections() {
      this.loading = true;
      try {
        this.collections = await CollectionAPI.getAll();
      } catch (error) {
        this.collections = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    changeCategory() {
      // let old_category_id = this.category_id;
      // let categorySelected = this.categories.find(
      //   (item) => item.id === this.productSelected.ficha_tecnica.category_id
      // );
      this.category_id = this.product.category_id;
      // if (old_category_id !== this.category_id) {
      //   // this.subcategories = [];
      //   // this.getSubcategories();
      // }
    },
    showImageGalery(material) {
      this.attributeSelected = material;

      if (this.collection == "") {
        let collectionId = this.collections[this.collections.length - 1].id;
        this.collection = collectionId;
        this.getPhotosProducts();
      } else {
        if (this.photos.length > 0) {
          this.showImages = true;
        } else {
          this.showImages = false;
        }
        if (Object.keys(material.photo).length > 0) {
          this.radioPhoto = material.photo.id;
        } else {
          this.radioPhoto = "";
        }
      }

      this.dialogImageGalery = true;
    },
    async getPhotosProducts() {
      console.log(this.provider_id);
      console.log(this.collection);
      this.loadingPhotos = true;
      try {
        let response = await fetch(
          `${URL}photo-galery?company_id=${this.provider_id}&collection_id=${this.collection}`
        );
        let res = await response.json();
        console.log(res);
        let data = [];
        res
          .map((galery) => galery.photos)
          .map((element) => {
            element.map((item) => {
              data = data.concat(item);
            });
          });

        data = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        this.photos = data.map((photo) => ({
          ...photo,
          children: [],
          full_url: this.getUrlImage(photo.url),
        }));
        let photosChildren = this.photos.filter(
          (photo) =>
            photo.name === "0248_3593_LUTT_FUMEX_COBRE_003.jpg" ||
            photo.name === "0248_3593_LUTT_FUMEX_COBRE_002.jpg"
        );
        this.photos = this.photos.filter(
          (photo) =>
            photo.name !== "0248_3593_LUTT_FUMEX_COBRE_003.jpg" &&
            photo.name !== "0248_3593_LUTT_FUMEX_COBRE_002.jpg"
        );
        let index = this.photos.findIndex(
          (photo) => photo.name === "0248_3593_LUTT_FUMEX_COBRE_001.jpg"
        );
        this.photos[index]["children"] = photosChildren;
        console.log(this.photos);
      } catch (error) {
        this.photos = [];
        console.log(error);
      } finally {
        this.showImages = true;
        this.loadingPhotos = false;
      }
    },
    getUrlImage(image) {
      return `${URL_IMAGE}${image}`;
    },
    nextPage(page) {
      if (this.xml.produtos.produto.length === 0) {
        this.showAlert(
          "error",
          "Selecione um arquvio para poder avançar na importação"
        );
        return false;
      }
      this.produtos = this.xml.produtos.produto;
      this.produtos = this.produtos.map((item) => ({
        ...item,
        cest:
          Array.isArray(item.cest) && item.cest.length == 0 ? "" : item.cest,
        ficha_tecnica: {
          unit_id:
            this.units.find((unit) => unit.code === item.punid) !== undefined
              ? this.units.find((unit) => unit.code === item.punid).id
              : "",
          extra_fields: [],
        },
        attributes: this.getMaterials(item),
      }));
      console.log(this.produtos);
      this.productSelected = this.produtos[0];
      // this.getMaterials(this.productSelected);
      this.page = page;
      console.log(this.productSelected);
    },
    changeProductType() {
      const type = this.productTypes.find(
        (item) => item.id === this.productSelected.ficha_tecnica.product_type_id
      );
      const fields = type.fields;
      this.extraFields = fields;
    },
    filterMaterials(materials) {
      return materials.filter(
        (item) => item.material !== false && item.cor !== false
      );
    },
    goToPrev() {
      if (this.indexProduct === 0) return;

      this.loadingProductPrev = true;
      setTimeout(() => {
        this.loadingProductPrev = false;
        this.$vuetify.goTo(0, {
          duration: 200,
          offset: 0,
          easing: "easeInOutCubic",
        });
      }, 500);

      this.indexProduct = this.indexProduct - 1;
      this.productSelected = this.produtos[this.indexProduct];
      // this.getMaterials(this.productSelected);
      this.showSalvar = false;
    },
    goToNext() {
      if (this.indexProduct === this.produtos.length - 1) {
        this.showSalvar = true;
        return;
      }
      this.loadingProduct = true;
      setTimeout(() => {
        this.loadingProduct = false;
        this.$vuetify.goTo(0, {
          duration: 200,
          offset: 0,
          easing: "easeInOutCubic",
        });
        if (this.validateRequiredFields()) {
          this.$refs.form.resetValidation();
          this.showSalvar = false;
          this.indexProduct = this.indexProduct + 1;
          this.productSelected = this.produtos[this.indexProduct];
          // this.getMaterials(this.productSelected);
          if (this.indexProduct === this.produtos.length - 1) {
            this.showSalvar = true;
            return;
          }
        }
      }, 600);
    },
    validateRequiredFields() {
      return this.$refs.form.validate();
    },
    filterByCategory(subcategories) {
      if (this.category_id === "") return [];
      return subcategories.filter(
        (sub) => sub.category_id === this.category_id
      );
    },
    saveProducts() {
      this.dialogSaveProducts = true;
    },
    async confirmSave() {
      this.dialogSaveProducts = false;
      console.log(this.produtos);
      console.log(this.xml.gerador);
      this.loading = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}product-import/save`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            gerador: this.xml.gerador,
            produtos: this.produtos,
          }),
        });
        if (res) {
          let response = await res.json();
          console.log(response);
          this.$router.push({ name: "ProductListImport" });
          // ProductListImport
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    showAlert(type, message) {
      this.typeAlert = type;
      this.messageAlert = message;
      this.statusAlert = true;
    },
    hideAlert() {
      this.statusAlert = true;
    },
    handleClickPhoto(id) {
      this.radioPhoto = id;
    },
    handleSelectPhoto() {
      let photoSelected = this.photos.find(
        (item) => item.id === this.radioPhoto
      );
      let index = this.productSelected.attributes.findIndex(
        (item) =>
          item.material.id === this.attributeSelected.material.id &&
          item.color.id === this.attributeSelected.color.id
      );
      let copyAttr = this.productSelected.attributes[index];
      copyAttr.photo_url = photoSelected.full_url;
      copyAttr.photo = photoSelected;
      this.productSelected.attributes.splice(index, 1, copyAttr);
      this.dialogImageGalery = false;
    },
    showImageFullScreen(image) {
      this.imageFullScreen = image;
      this.dialogImageFullScreen = true;
    },
    saveProduct() {
      alert("Salvar Produto");
    },
    getItensPhoto(photo) {
      let photos = [];
      photos.push(photo);
      photo.children.map((p) => photos.push(p));
      return photos;
    },
  },
};
</script>

<style scoped>
.border-table {
  border: 1px solid #dddddd !important;
}
table th + th {
  border-left: 1px solid #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
  margin-bottom: 2px;
}
.align-self-center {
  align-self: center;
}
.image-product {
  cursor: pointer;
}
</style>
